import React, { useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import { MiniDialogModalTranslationsContext } from '../../../context/MiniDialogModalTranslationsContext.js';
import styles from '../mini-dialog.module.css.js';

const parseKeywords = (text) => {
    return text.replace(/\[/g, `<span class="${styles.keyword}">`).replace(/\]/g, '</span>');
};
function MiniDialogLine({ text, keywordsHidden, actor, audioUrl, onPlay, onPause, onRecord, urlLoaded, playMode, mediaPlayerStatus, urlPrefix, }) {
    const translations = useContext(MiniDialogModalTranslationsContext);
    const formattedText = useMemo(() => {
        return parseKeywords(text);
    }, [text]);
    const [recordingSession, setRecordingSession] = useState();
    const [recordingUrl, setRecordingUrl] = useState();
    const dialogPlaying = playMode === 'DIALOG' && mediaPlayerStatus === 'playing';
    const audioPlaying = urlLoaded ? urlLoaded === audioUrl && mediaPlayerStatus === 'playing' : false;
    const audioPlayDisabled = Boolean(dialogPlaying || !onPlay || !audioUrl || actor.mute);
    const recordingPlaying = urlLoaded ? urlLoaded === recordingUrl && mediaPlayerStatus === 'playing' : false;
    const recordingPlayDisabled = Boolean(dialogPlaying || !onPlay || !recordingUrl);
    const activeLine = urlLoaded
        ? (urlLoaded === audioUrl || urlLoaded === recordingUrl) &&
            (mediaPlayerStatus === 'playing' || mediaPlayerStatus === 'paused')
        : false;
    return (React.createElement("tr", { className: classNames(styles.borderBottom, {
            [styles.active]: activeLine,
        }) },
        React.createElement("td", { className: classNames(styles.tableCell, styles.avatarWrapper) },
            React.createElement("div", { className: styles.avatar, "data-testid": 'avatar' }, actor.image && React.createElement("img", { src: `${urlPrefix || ''}/api/files/${actor.image}`, alt: actor.name }))),
        React.createElement("td", { className: classNames(styles.tableCell, styles.actor) }, actor.name),
        React.createElement("td", { className: classNames(styles.tableCell, {
                [styles.blank]: keywordsHidden,
            }) },
            React.createElement("div", { className: classNames(styles.text, {
                    [styles.visuallyHideText]: actor.hideText,
                }), dangerouslySetInnerHTML: { __html: formattedText } })),
        React.createElement("td", { className: classNames(styles.tableCell, styles.actions) }, !dialogPlaying && audioPlaying ? (React.createElement("button", { type: 'button', title: translations.pauseTitle, className: classNames(styles.roundedButton, styles.pauseButton), onClick: onPause },
            React.createElement("i", { className: 'bc-icon bc-icon-pause-outline', role: 'img' }))) : (React.createElement("button", { type: 'button', title: translations.playTitle, disabled: audioPlayDisabled, className: classNames(styles.roundedButton, { [styles.disabled]: audioPlayDisabled }), onClick: () => {
                if (onPlay && audioUrl) {
                    onPlay(audioUrl);
                }
            } },
            React.createElement("i", { className: 'bc-icon bc-icon-audio-play', role: 'img' })))),
        React.createElement("td", { className: classNames(styles.tableCell, styles.actions) },
            !recordingSession ? (React.createElement("button", { type: 'button', title: translations.recordTitle, disabled: Boolean(!onRecord || dialogPlaying), className: classNames(styles.roundedButton, {
                    [styles.disabled]: Boolean(!onRecord || dialogPlaying),
                }), onClick: async () => {
                    if (onRecord) {
                        const record = await onRecord();
                        record && setRecordingSession({ stop: record.stopRecording });
                    }
                } },
                React.createElement("i", { className: 'bc-icon bc-icon-record', role: 'img' }))) : (React.createElement("button", { type: 'button', title: translations.stopRecordTitle, className: styles.stopRecordButton, onClick: async () => {
                    const url = await recordingSession.stop();
                    setRecordingUrl(url);
                    setRecordingSession(undefined);
                } },
                React.createElement("i", { className: 'bc-icon bc-icon-audio-stop', role: 'img' }))),
            recordingPlaying ? (React.createElement("button", { type: 'button', title: translations.pauseRecordingTitle, className: classNames(styles.roundedButton, styles.pauseButton), onClick: onPause },
                React.createElement("i", { className: 'bc-icon bc-icon-pause-outline', role: 'img' }))) : (React.createElement("button", { type: 'button', title: translations.playRecordingTitle, disabled: recordingPlayDisabled, className: classNames(styles.roundedButton, { [styles.disabled]: recordingPlayDisabled }), onClick: () => {
                    if (onPlay && recordingUrl) {
                        onPlay(recordingUrl);
                    }
                } },
                React.createElement("i", { className: 'bc-icon bc-icon-audio-play', role: 'img' }))))));
}

export { MiniDialogLine };
